export const SET_USERS_LIST = "SET_USERS_LIST";


export const setUsersList = (user) => ({
  type: SET_USERS_LIST,
  payload: user,
});

